import { GET_URL_MAPPINGS_ACTION_BEGIN, GET_URL_MAPPINGS_ACTION_SUCCESS, GET_URL_MAPPINGS_ACTION_FAIL , SUCCESS} from './types';
import Helper from '../components/Helper';

export const getUrlMappingsAction = (formData,actionUrl) => dispatch => {
    const dispatcher=dispatch;
    Helper.customFetchApi(actionUrl,formData,false,GET_URL_MAPPINGS_ACTION_BEGIN,GET_URL_MAPPINGS_ACTION_SUCCESS,GET_URL_MAPPINGS_ACTION_FAIL,dispatcher);
}
